"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M23 20V4H1v16zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5z"
}), 'PanoramaSharp');